enum AlertExecutionState {
    FAILED = "FAILED", SUCCEEDED = "SUCCEEDED", SUCCEEDED_NO_UPDATES="SUCCEEDED_NO_UPDATES", EMPTY = "EMPTY"

}

export default AlertExecutionState;